import { Outlet } from 'react-router-dom';
import { Page, PageInner } from '@hopskipdrive/react-components';

import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';
import { useNavigationGuard } from '../../../routes/useNavigationGuard';
import { AccountNameBar } from '../../features/AccountNameBar/AccountNameBar';
import { BundleExpiredBanner } from '../../features/BundleExpiredBanner';
import { ImpersonationBanner } from '../../features/ImpersonationBanner';
import { PageLoader } from '../PageLoader';
import { SidebarNav } from '../SidebarNav';

export const PageLayout = () => {
  const { user, loading, isImpersonating } = useAuthQuery();

  useNavigationGuard();

  return !loading ? (
    <>
      {user ? (
        <div>
          {isImpersonating && (
            <ImpersonationBanner organizerName={`${user.firstName} ${user.lastName}`} accountName={user.accountName} />
          )}
          <BundleExpiredBanner />
          <Page>
            <SidebarNav />
            <PageInner>
              {!isImpersonating && <AccountNameBar name={user.accountName} loading={loading} />}
              <Outlet />
            </PageInner>
            <PageLoader />
          </Page>
        </div>
      ) : (
        <Outlet />
      )}
    </>
  ) : null;
};
